import { svg } from "lit";
const icon = svg `<path d="M16.5866 29.4237L7.16357 20.0007L16.6037 10.5605L18.0951 12.0413L11.1827 18.9537H32.8537V21.0476H11.1827L18.078 27.943L16.5866 29.4237Z" fill="currentColor"/>`;
export default icon;
